import React from 'react';
import { CardContent, Typography } from '@mui/material';
import { format } from 'date-fns';

import { LinearProgress } from 'components/LinearProgress';
import { ReactComponent as ClockIcon } from 'images/taskCard/clock.svg';
import { ReactComponent as CircleGreenCheckIcon } from 'images/dashboard/circular-green-check.svg';
import useTaskCard from 'hooks/TaskCard';
import { FilledButton } from 'shared-components/Buttons';
import TaskCardSkeleton from './TaskCardSkeleton';
import {
  StyledCard,
  FirstContentRow,
  SecondContentRow,
  CardTitle,
  Description,
  DurationTime,
  StyledProgress,
  Completed,
} from './styles';
import { formatDate } from 'utils/date';

const TaskCard = ({ id, refetchProfileParticipantTasks }) => {
  const taskDetails = useTaskCard(id, refetchProfileParticipantTasks);
  const {
    title,
    description,
    progress,
    completedAt,
    status,
    duration,
    buttonProps,
    isLoading,
  } = taskDetails;

  if (isLoading) return <TaskCardSkeleton />;

  return (
    <StyledCard
      sx={{
        maxWidth : { xs: '100%', lg: '400px' },
        minWidth : '240px'
      }}>
      <CardContent>
        <FirstContentRow>
          <CardTitle
            variant='h6'>{title}</CardTitle>
          <Description
            variant='pl3'>{description}</Description>
          {duration && (
            <DurationTime>
              <ClockIcon />
              <Typography
                variant='pl3'>{duration}</Typography>
            </DurationTime>
          )}
          {status === 'completed' && (
            <Completed>
              <CircleGreenCheckIcon />
              <Typography
                variant='pl3'>
                Completed {formatDate(completedAt, 'LL')}
              </Typography>
            </Completed>
          )}
        </FirstContentRow>
        <SecondContentRow>
          {progress && (
            <StyledProgress>
              <Typography
                variant='pb5'>{progress}% completed</Typography>
              <LinearProgress
                variant='determinate' value={progress}
              />
            </StyledProgress>
          )}
          <FilledButton
            fullWidth height='44px' {...buttonProps}
          />
        </SecondContentRow>
      </CardContent>
    </StyledCard>
  );
};

export default TaskCard;
